/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { chatListModelSchema } from "./chatListModelSchema.ts";
import { z } from "zod";

export const chatListModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => chatListModelSchema))
    })